import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.core.css';
import 'react-quill/dist/quill.snow.css';
import classNames from 'classnames';
import './RichTextEditor.styl';

const fullModules = {
  toolbar: [
    [{header: [1, 2, 3, false]}],
    ['bold', 'italic', 'underline', 'strike'],
    [{list: 'ordered'}, {list: 'bullet'}],
    ['clean'],
  ],
};

const abbreviatedModules = {
  toolbar: [
    [{header: [1, 2, 3, false]}],
    ['bold', 'italic', 'underline'],
    [{list: 'ordered'}, {list: 'bullet'}],
  ],
};

/**
 * For now, this and UserTaggableInput both use Quill.
 *
 * If we later have a need for user taggable + "rich" (including the toolbar),
 * consider combining (at least underneath) these two components
 */
export default class RichTextEditor extends React.Component {
  onChange = (markup, delta, source, editor) => {
    const html = editor.getHTML();
    this.props.onChange(html);
  };

  render() {
    const {placeholder, value, disabled, className, abbreviatedOptions} = this.props;

    if (disabled) {
      return <RichText dangerousText={value} className={'disabled-rich-text-editor'} />;
    }

    return (
      <div
        className={classNames('rich-text-editor', className)}
        onClick={() => this.quill.editor.focus()}>
        <ReactQuill
          placeholder={placeholder}
          modules={abbreviatedOptions ? abbreviatedModules : fullModules}
          theme="snow"
          ref={r => {
            this.quill = r;
          }}
          defaultValue={value}
          onChange={this.onChange}
          readOnly={disabled}
        />
      </div>
    );
  }
}

export const RichText = ({dangerousText, ...props}) => (
  <div dangerouslySetInnerHTML={{__html: dangerousText}} {...props} />
);
